<form [formGroup]="signUpForm" (ngSubmit)="onContinue()" class="form-container">
  <div class="inputs">
    <ling-input
      [maxLength]="50"
      label="{{ 'dialogs.signUp.name.label' | translate }}"
      placeholder="{{ 'dialogs.signUp.name.placeholder' | translate }}"
      formControlName="name"
      autocomplete="name"
      [validationTrigger]="isSubmit"
    ></ling-input>
    <ling-input
      label="{{ 'dialogs.signUp.email.label' | translate }}"
      placeholder="{{ 'dialogs.signUp.email.placeholder' | translate }}"
      type="email"
      formControlName="email"
      autocomplete="email"
      [validationTrigger]="isSubmit"
    ></ling-input>
    <ling-input
      label="{{ 'dialogs.signUp.password.label' | translate }}"
      placeholder="{{ 'dialogs.signUp.password.placeholder' | translate }}"
      type="password"
      formControlName="password"
      [validationTrigger]="isSubmit"
    ></ling-input>
    <ling-input
      label="{{ 'dialogs.signUp.repeatPassword.label' | translate }}"
      placeholder="{{
        'dialogs.signUp.repeatPassword.placeholder' | translate
      }}"
      type="password"
      formControlName="confirmPassword"
      [validationTrigger]="isSubmit"
    ></ling-input>
    <ling-input
      [validationTrigger]="isSubmit"
      type="checkbox"
      formControlName="acceptPolicy"
    >
      <p class="policy-block">
        {{ "dialogs.signUp.tos.byCreatingYouAccept" | translate }}
        <a [routerLink]="'/contract'" [target]="'_blank'">{{
          "dialogs.signUp.tos.contractTerms" | translate
          }}</a>
        {{ "dialogs.signUp.tos.andOur" | translate }}
        <a [routerLink]="'/privacy'" [target]="'_blank'">{{
          "dialogs.signUp.tos.privacyPolicy" | translate
          }}</a
        >.
      </p>
    </ling-input>
  </div>
  <button mat-flat-button color="primary">
    {{ "dialogs.signUp.continue" | translate }}
  </button>
</form>
